const mvSwiper = new Swiper('.mv-swiper', {
  loop: true,
  effect: 'slide',
  fadeEffect: {
    crossFade: true
  },
  slidesPerView: 1.2,
  spaceBetween: 20,
  centeredSlides: true,
  autoplay: {
    delay: 4000,
  },
  speed: 500,
  preloadImages: true,
  lazy: false,
  on: {
    init: function () {
      this.params.easing = 'cubic-bezier(0.895, 0.03, 0.685, 0.22)';
      
      // Swiper初期化後に画像のopacityを変更
      document.querySelectorAll('.swiper_img').forEach(function (img) {
        setTimeout(function () {
          img.style.opacity = 1;
        }, 100);
      });
      
      // navigationボタンのopacityを遅らせて変更
      setTimeout(function () {
        document.querySelector('.swiper-button-next').style.opacity = 1;
        document.querySelector('.swiper-button-prev').style.opacity = 1;
      }, 500); 
    },
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
});
